export default __webpack_public_path__ + "static/media/world.6ecd3346.svg";